import React, { useEffect, useState } from 'react';
import './Atmosfera.css';
import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion';

/**
 * Campo atmosferico de la pagina.
 *
 * Los halos no pertenecen a ninguna seccion: viven en una capa fija detras de
 * todo el contenido. Al no estar recortados por los limites de cada seccion,
 * cruzan de una a otra y es lo que da continuidad, en lugar de una franja
 * decorativa en cada empalme.
 *
 * La capa se desplaza con el scroll a distinta velocidad que el contenido, asi
 * que la composicion de color nunca se repite de arriba a abajo.
 */
const Atmosfera = () => {
  const sinMovimiento = usePrefersReducedMotion();
  const [desplazamiento, setDesplazamiento] = useState(0);

  useEffect(() => {
    if (sinMovimiento) {
      setDesplazamiento(0);
      return undefined;
    }

    let frame = null;

    const update = () => {
      frame = null;
      const alcance = document.body.scrollHeight - window.innerHeight;
      // Normalizado 0..1: la capa recorre una fraccion del total, de modo que
      // los halos derivan mas lento que el contenido.
      setDesplazamiento(alcance > 0 ? window.scrollY / alcance : 0);
    };

    const onScroll = () => {
      if (frame === null) frame = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    return () => {
      if (frame !== null) cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [sinMovimiento]);

  return (
    <div
      className="atmosfera"
      aria-hidden="true"
      style={{ '--recorrido': desplazamiento }}
    >
      <div className="atmosfera-capa">
        <div className="atmosfera-halo atmosfera-halo--1" />
        <div className="atmosfera-halo atmosfera-halo--2" />
        <div className="atmosfera-halo atmosfera-halo--3" />
        <div className="atmosfera-halo atmosfera-halo--4" />
        <div className="atmosfera-halo atmosfera-halo--5" />
        <div className="atmosfera-halo atmosfera-halo--6" />
      </div>
      {/* Grano fino: rompe el bandeado de los degradados grandes sobre fondo
          oscuro y le da textura a la superficie. */}
      <div className="atmosfera-grano" />
    </div>
  );
};

export default Atmosfera;
